import { useEffect } from 'react';

import { PharmaCompanyDialog } from 'entities/pharmaceutical-company';

import { Country, PharmaceuticalCompany, UpdatePharmaceuticalCompanyDto } from 'shared/api';

type Props = {
  company: PharmaceuticalCompany | null;
  countries: Country[];
  isOpen: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: (data: UpdatePharmaceuticalCompanyDto) => void;
};

export const EditPharmaCompany = ({ company, countries, isOpen, isSuccess, isLoading, onClose, onSubmit }: Props) => {
  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess, onClose]);

  return (
    <PharmaCompanyDialog
      title="Edit pharmaceutical company"
      isOpen={isOpen}
      company={company ?? undefined}
      countries={countries}
      isLoading={isLoading}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};
